import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteProduzione, useProduzione, useUpdateProduzione } from '../../hooks/produzioni'
import { Produzione } from '../../types'
import ProduzioneForm from '../../components/ProduzioneForm'

export default function ProduzioneEdit() {
  const { id } = useParams()
  const { data: produzione } = useProduzione(Number(id!))
  const deleteProduzione = useDeleteProduzione()
  const updateProduzione = useUpdateProduzione()
  const [modalRm, modalRmActions] = useModalTrigger<Produzione>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/produzioni">Produzioni</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {produzione?.nome}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(produzione)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>

      <div className="py-3 overflow-y-auto flex-1">
        <ProduzioneForm
          produzione={produzione}
          save={(prod) =>
            updateProduzione.mutateAsync(prod).then(() =>
              toast.success('Produzione aggiornata', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare la produzione {modalRm.value.nome} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btnoutline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteProduzione.isLoading}
            onClick={async () => {
              await deleteProduzione.mutateAsync(modalRm.value!.id)
              navigate('/produzioni')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
